import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Profile',
    column_type: 'id',
    label_key_path: 'profile.id',
  },
  created_at: {
    model_name: 'Profile',
    column_type: 'datetime',
    label_key_path: 'profile.createdAt',
  },
  updated_at: {
    model_name: 'Profile',
    column_type: 'datetime',
    label_key_path: 'profile.updatedAt',
  },
  name: {
    model_name: 'Profile',
    column_type: 'string',
    label_key_path: 'profile.name',
  },
  phone: {
    model_name: 'Profile',
    column_type: 'string',
    label_key_path: 'profile.phone',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
